const lightTheme = {
  colors: {
    Gprimary: '#2336FF',
    Cmk: '#0d0f11',
    DarkCyan: '#3a434b',
    Toggleprimary: '#2336FF',
    cyanBlue: '#d7dce0',
    CardDark: '#828282',
    body: '#FFFFFF',
    primary: '#2336FF',
    secondary: '#02073E',
    accent: '#a8affc',
    transactionHead: '#353fa5',
    transactionColor: '#BDBDBD',
    white: '#FFFFFF',
    sideBar: '#F4F5F6',
    successGreen: '#4CD964',
    investColor: '#003A00',
    resetColor: '#6E7191',
    dark: '#121212',
    whitesmoke: '#ccc',
    red: 'red',
    gray: '#6E7191',
    gray2: '#4F4F4F',
    gray3: '#828282',
    black: '#000000',
    grey: ' #E5E5E5',
    darkgrey: '#4E4B66',
    activeBlue: '#00327C',
    NeutralBlack: '#09101D',
    AccountNumber: '#151522',
    CollaboBlue: '#5766FF',
    darkShade: '#666666',
    Background: '#f8f9fe',
    TargetColor: '#00C48C',
    Emergency: '#EF5DA8',
    Cardwhite: '#FFFFFF',
    Btnprimary: '#2336FF',
    Transgrey: '#E5E5E5',
    BtnWhite: '#FFFFFF',
    iconRes: '#4E4B66',
    Faqwhite: '#FFFFFF',
    PWhite: '#FFFFFF',
    stillSellingBg: '#F3F3F3',
    stillSellingColor: '#00327C',
    soldOutBg: '#FFE7E7',
    soldOutColor: '#E80101',
    investTextColor: '#00327C',
    referralBg: '#F8F8F8',
    navyBlue: '#212761',
    navyBlue2: '#495B7F',
    darkNavyBlue: ' #2D3266',
    secondPrimary: '#5766FF',
    moneyInterestCard: '#EEF4FF;',
    homeQuickSaveBg: '#6979F8',
    transactionBgColor: '#F8F8F8',
    transactionTextColor: '#4F4F4F',
    primaryBlue: '#6979F8',
    emergencyColor: '#EF5DA8',
    emergencyColorTwo: '#FBF3F7',
    profileBlack: '#7c80a4',
    AccountDark: '#999999',
    contestPrimary: '#7C80A4',
    exploreColor: '#01c4a0',
  },
  fontFamily: {
    latoSemiBold: 'Inter',
    latoBold: 'Inter',
    inter: 'Inter',
    latoLight: 'Inter',
    visuelt: 'Inter',
    Euclid: 'Inter',
    Mulish: 'Inter',
  },
  fontSize: {
    xx5: '96px',
    xx4: '48px',
    xx2: '36px',
    xxxl: '36px',
    xxl: '32px',
    xx3: '28px',
    xl: '24px',
    s: '14px',
    x2: '18px',
    x3: '14px',
    x4: '12px',
    x11: '11px',
    x5: '16px',
    x6: '20px',
    x7: '10px',
    x8: '15px',
  },

  responsive: {
    ipad: '768px',
    mobile: '600px',
    laptop: '992px',
  },
}

const darkTheme = {
  colors: {
    PWhite: '#FFFFFF',
    Gprimary: '#2336FF',
    Toggleprimary: '#6E7191',
    body: '#25253C',
    primary: '#FFFFFF',
    secondary: '#02073E',
    transactionHead: '#353fa5',
    accent: '#a8affc',
    white: '#25253C',
    successGreen: '#4CD964',
    investColor: '#FFFFFF',
    resetColor: '#6E7191',
    dark: '#FFFFFF',
    whitesmoke: '#ccc',
    red: 'red',
    gray: '#FFFFFF',
    black: '#FFFFFF',
    grey: ' #E5E5E5',
    gray3: '#828282',
    darkgrey: '#FFFFFF',
    activeBlue: '#00327C',
    NeutralBlack: '#09101D',
    CollaboBlue: '#5766FF',
    darkShade: '#666666',
    Background: '#f8f9fe',
    TargetColor: '#00C48C',
    Emergency: '#EF5DA8',
    Cardwhite: '#14142B',
    Btnprimary: '#2336FF',
    Transgrey: 'transparent',
    BtnWhite: '#FFFFFF',
    iconRes: '#FFFFFF',
    Faqwhite: '#14142B',
    referralBg: '#F8F8F8',
    navyBlue: '#212761',
    navyBlue2: '#495B7F',
    darkNavyBlue: ' #2D3266',
    secondPrimary: '#5766FF',
    moneyInterestCard: '#EEF4FF',
    homeQuickSaveBg: '#6979F8',
    transactionBgColor: '#BDBDBD',
    transactionTextColor: '#4F4F4F',
    primaryBlue: '#6979F8',
    emergencyColor: '#EF5DA8',
    emergencyColorTwo: '#FBF3F7',
    contestPrimary: '#7C80A4',
  },
  fontFamily: {
    latoSemiBold: 'Inter',
    latoBold: 'Inter',
    inter: 'Inter',
    latoLight: 'Inter',
    visuelt: 'Inter',
    Euclid: 'Inter',
    Mulish: 'Inter',
  },
  fontSize: {
    xx5: '96px',
    xx4: '48px',
    xx2: '36px',
    xxxl: '36px',
    xxl: '32px',
    xx3: '28px',
    xl: '24px',
    s: '14px',
    x2: '18px',
    x3: '14px',
    x4: '12px',
    x5: '16px',
    x6: '20px',
    x7: '10px',
    x8: '15px',
  },

  responsive: {
    ipad: '768px',
    mobile: '500px',
    laptop: '1200px',
  },

  letterSpacing: {
    lS: '.58px',
  },

  // lineHeight: {
  //   lH: '1.5em'
  // }
}

export { lightTheme, darkTheme }
